

// 域名 https://api.gaokaozhitongche.com 接口
const apiUrl = process.env.NODE_ENV === "production" ? '//api.gaokaozhitongche.com' : 'https://testapi.gaokaozhitongche.com'
// const xgkUrl = process.env.NODE_ENV === "production" ? '//xgk.gkztc.cn' : '//testxgkapi.gkztc.cn'

const v1 = '/v1' //旧接口
const v2 = '/v2' //新接口
// 点播
export const VOD_CLASS_LIST = v2 + "/vod/class-list"; // 分类列表
export const VOD_COURSE_LIST = v2 + "/vod/course-list"; // 课程列表
export const VOD_COURSE_DETAIL = v2 + "/vod/course-detail"; // 课程详情
export const VOD_LESSON_LIST = v2 + "/vod/lesson-list"; // 课程目录
export const VOD_TEACHER_DETAIL = v2 + "/vod/teacher-detail"; // 讲师详情
export const VOD_TEACHER_COURSES = v2 + "/vod/teacher-courses"; // 讲师课程
export const VOD_COURSE_RECOM = v2 + "/vod/course-recom"; //推荐列表
export const VOD_LESSON_DETAIL = v2 + "/vod/lesson-detail"; //小节回放
export const VOD_LESSON_RECOM = v2 + "/vod/lesson-recom"; //小节推荐
export const VOD_WATCH_LOG = v2 + "/vod/watch-log"; //小节推荐
export const VOD_TRADE_DETAIL = v2 + "/vod/trade-detail"; //支付详情页
export const VOD_USER_ORDERS = v2 + "/vod/user-orders"; //我的订单
export const VOD_PACKAGE_INFO = v2 + "/vod/vod-package-info"; //套餐课程列表
export const VOD_AFTER_PAY = v2 + '/vod/course-after-pay' // 支付成功后的二维码



// 支付
export const TRADE_VOD_PREPAY = v2 + "/trade/vod/prepay" // 创建预支付订单
export const TRADE_VOD_SYN = v2 + "/trade/vod/syn" // 同步订单状态
export const TRADE_VOD_ALIPAY = v2 + "/trade/vod/alipay" // 支付宝支付订单
export const TRADE_VOD_WECHATPAY = v2 + "/trade/vod/wechatpay" // 微信支付订单
export const TRADE_VOD_CHEBIPAY = v2 + "/trade/vod/chebipay" // 车币支付订单
export const TRADE_CHEBI_BALANCE = v2 + "/trade/chebi/balance" // 车币余额
export const TRADE_CHEBI_RECHARGE = v2 + "/trade/chebi/recharge" // 车币充值
export const TRADE_CHEBI_ALIPAY = v2 + "/trade/chebi/alipay" // 支付宝充值
export const TRADE_CHEBI_WECHATPAY = v2 + "/trade/chebi/wechatpay" // 微信充值
export const TRADE_CHEBI_SYN = v2 + "/trade/chebi/syn" // 同步订单状态
export const TRADE_CHEBI_PRODUCT = v2 + "/trade/chebi/product" // 充值产品列表

//车车会员支付
export const MEMBER_INDEX = v2 + "/member/member-index" // 车车会员主页
export const MEMBER_PRE = v2 + "/member/buy-member-pre" // 购买车车会员
export const PAY_INFO = v2 + "/member/pay-page-info" // 付款界面价格
export const MEMBER_ACOUNT_DETAIL = v2 + "/member/member-amount-detail" // 付款界面价格

export const MEMBER_AUTO_RENEW_PRE = v2 + "/member/member-auto-renew-pre" // 购买车车会员自动续费预请求
export const MEMBER_AUTO_RENEW_STATUS = v2 + "/member/member-auto-renew-status" // 车车会员自动续费状态

export const BUY_POST = v2 + "/member/buy-member-post" // 购买后请求


// 直播
export const VOD_LIVE_DETAIL = v2 + "/vod/live-detail" // 直播详情
export const VOD_GROUP_MSG_HISTORY = v2 + "/vod/group-msg-history" // 历史消息
export const VOD_LIVE_WATCH_COUNT = v2 + "/vod/live-watch-count" // 观看人数轮循

// 在线讲座
export const LECTURE_LIST = v2 + "/vod/lecture-list" // 讲座列表
export const LECTURE_DETAIL = v2 + "/vod/lecture-detail" // 讲座直播间
export const LECTURE_APPLY = v2 + "/vod/lecture-apply" // 讲座报名
export const LECTURE_VERIFY = v2 + "/vod/lecture-verify" // 报名验证
export const LECTURE_BOOKING = v2 + "/vod/lecture-booking" // 预约咨询
export const LECTURE_APP_BOOKING = v2 + "/vod/lecture-app-booking" // app预约咨询
export const LIVE_WATCH_LOG = v2 + "/vod/live-watch-log" // 观看历史上报
export const FAVORITE = v2 + "/zy-colleges/favorite" // 关注院校

// 基础接口
export const PROVINCE_LIST = v2 + "/base/province-list" // 省份列表
export const CITY_LIST = v2 + "/base/city-list" // 城市列表
export const BASE_FILE_UPLOAD = v2 + "/base/file/upload" // 文件上传
export const AD_LIST = v2 + "/ad/list" // 广告
export const AD_POSITION_AD = v2 + "/ad/position-ad" // 具体位置广告
export const AD_STATUS = v2 + "/ad/statis" // 广告统计
export const BASE_IP = apiUrl + v2 + "/base/ip-address" // 用户ip地址
export const NOTICE_READ = v2 + "/postman/notice/read" // 设置已读
export const POSTMAN_NOTICE_VIEW = v2 + "/postman/notice/view" // 获取未读消息数量
export const WISH_USER_INFO = v2 + '/wish-zy-cors/zy-user-info' // 志愿用户信息
export const FILE_UPLOAD = v2 + '/base/file/upload' // 图片上传


// 城市信息api
export const APP_MANAGE_CITY_PROVINCE = v2 + "/app-manage/city/province" // 省份列表
export const APP_MANAGE_CITY_CITY = v2 + "/app-manage/city/city" // 城市列表

// 专题直播
export const TEACHER_LIST = v2 + "/vod/teacher-list" // 专题列表
export const TEACHER_LECTURE_LIST = v2 + "/vod/teacher-lecture-list" // 专题直播列表
export const TEACHER_CHELIVE_LIST = v2 + "/vod/teacher-chelive-list" // 车车直播专题列表


// 登录

export const SEND_RANDOMCODE = v2 + "/auth/send-randomcode" // 发送验证码
export const LOGIN_BY_VCODE = v2 + "/auth/login-by-vcode" // 验证码登录
export const REFRESH_TOKEN = v2 + "/auth/refresh-token" // 刷新token

// 志愿支付
export const SITE_ORDER_PAY = v1 + "/order/pay" // 志愿支付

// export const OAUTH2_TOKEN =  v1 +  "/oauth2/token" // token

// 验证码登录  微信授权登录
// export const DEFAULT_SENDRANDOMCODE = v1 + "/default/send-randomcode" //发送验证码登录
// export const DEFAULT_LOGIN_BY_VCODE = v1 +  "/default/login-by-vcode"  //通过验证码登录
// export const WX_ACCESSTOKEN = v1 +  "/wx/accesstoken"
// export const DEFAULT_WX_REGISTER = v1 +  "/default/wx-register"
// export const DEFAULT_SEND_REG_RANDOM_CODE = v1 +  "/default/send-reg-random-code"
// export const DEFAULT_LOGINID = v1 +  "/default/loginid"


export const USER_VIEW = v2 + "/user/view" //获取用户信息

// v2 验证码登录  微信授权登录
export const OAUTH2_TOKEN = v2 + "/auth/refresh-token" // 刷新token
export const DEFAULT_SENDRANDOMCODE = v2 + "/auth/send-randomcode" //发送验证码登录
export const DEFAULT_LOGIN_BY_VCODE = v2 + "/auth/login-by-vcode"  //通过验证码登录
export const WX_ACCESSTOKEN = apiUrl + v2 + "/wx/accesstoken"
export const DEFAULT_WX_REGISTER = v2 + "/auth/wx-register"
export const DEFAULT_LOGINID = v2 + "/auth/loginid"
export const GET_WXMP_USER = v2 + "/auth/get-wxmp-user" // 获取微信用户信息

// 没有这个接口，发送验证码就DEFAULT_SENDRANDOMCODE
// export const DEFAULT_SEND_REG_RANDOM_CODE = v2 +  "/auth/send-reg-random-code"

export const WX_JSTICKET_PAY = v2 + "/wx/jsticket" // 微信 js-sdk配置  支付
export const WX_JSTICKET = v2 + "/wx/jsticket" // 微信 js-sdk配置
// export const WX_JSTICKET = "/wx/jsticket" // 微信 js-sdk配置


// 域名 https://app.gaokaozhitongche.com 接口

// 微信分享配置
// export const WX_JSTICKET =  "/wx/jsticket" // 微信 js-sdk配置
// 2020-百日誓师
export const PLEDGE2020_CREATE = "/service-pledge2020/create" // 创建
export const PLEDGE2020_SAVEFILE = "/service-pledge2020/savefile" // 保存图片
export const PLEDGE2020_CARD = "/service-pledge2020/card" // 查看帖子详情
export const PLEDGE2020_INDEX = "/service-pledge2020/index" // 首页
export const PLEDGE2020_COLLEGERANK = "/service-pledge2020/college-rank" // 高校排行列表
export const PLEDGE2020_CUEWORD = "/service-pledge2020/cue-word" // 院校名称提示词
export const PLEDGE2020_LIST = "/service-pledge2020/list" // 宣誓团列表
export const PLEDGE2020_LIKE = "/service-pledge2020/like" // 点赞
export const PLEDGE2020_LUNBO = "/service-pledge2020/lunbo" // 轮播

// 2021-百日誓师
export const PLEDGE2021_CREATE = v1 + "/service-pledge2021/create" // 创建
export const PLEDGE2021_SAVEFILE = v1 + "/service-pledge2021/savefile" // 保存图片
export const PLEDGE2021_CARD = v1 + "/service-pledge2021/card" // 查看帖子详情
export const PLEDGE2021_INDEX = v1 + "/service-pledge2021/index" // 首页
export const PLEDGE2021_COLLEGERANK = v1 + "/service-pledge2021/college-rank" // 高校排行列表
export const PLEDGE2021_CUEWORD = v1 + "/service-pledge2021/cue-word" // 院校名称提示词
export const PLEDGE2021_LIST = v1 + "/service-pledge2021/list" // 宣誓团列表
export const PLEDGE2021_LIKE = v1 + "/service-pledge2021/like" // 点赞
export const PLEDGE2021_LUNBO = v1 + "/service-pledge2021/lunbo" // 轮播
export const PLEDGE2021_MEDIA_LIST = v1 + "/service-pledge2021/media-list" // 语音列表
export const PLEDGE2021_UPLOAD_MEDIA = v1 + "/service-pledge2021/upload-media" // 语音上传
export const PLEDGE2021_USER_LIST = v1 + "/service-pledge2021/user-list" // 用户发帖记录
export const PLEDGE2021_USER_PROFILE = v1 + "/service-pledge2021/user-profile" // 填写收货地址
export const PLEDGE2021_ENERGY = v1 + "/service-pledge2021/energy" // 获取鼓励值




// 活动
//院校图片征集活动
export const ZY_COLLEGES_UPLOAD_PIC = v2 + "/zy-colleges/upload-pic" // 院校风光上传
export const ZY_COLLEGES_UPLOAD_PIC_HISTORY = v2 + "/zy-colleges/upload-pic-history" // 院校风光上传历史
export const ZY_COLLEGES_SEARCH = v2 + "/zy-colleges/search" // 院校搜索


// 自习室
export const ROOM_RANK = v2 + "/room/rank" // 院校搜索


// 送学霸笔记活动

export const XUEBA_INDEX = v1 + "/activity/xueba-index" // 首页
export const XUEBA_NOTE_INFO = v1 + "/activity/xueba-note-info" // 笔记详情
export const XUEBA_BUY = v1 + "/activity/xueba-buy" // 兑换
export const XUEBA_BUY_RECORD = v1 + "/activity/xueba-buy-record" // 兑换记录
export const XUEBA_INVITE = v1 + "/activity/xueba-invite" // 邀请记录
export const XUEBA_IS_FOLLOW = v1 + "/activity/xueba-is-follow" // 关注公众号


// 高考奖学金计划
export const CHECKIN_CHECK = v2 + "/app-manage/checkin/check" // 签到
export const CHECKIN_INDEX = v2 + "/app-manage/checkin/index" // 签到历史

export const JXJ2021_IS_FOLLOW = v1 + "/jxj2021/is-follow" // 关注公众号
export const JXJ2021_INVITED = v1 + "/jxj2021/invited" // 邀请好友
export const JXJ2021_RANK = v1 + "/jxj2021/rank" // 排行榜
export const JXJ2021_JOIN = v1 + "/jxj2021/join" // 加入计划
export const JXJ2021_task = v1 + "/jxj2021/task" // 计划列表
export const JXJ2021_MY_TASKS = v1 + "/jxj2021/my-tasks" // 完成记录
export const JXJ2021_UPLOAD = v1 + "/jxj2021/upload" // 上传成绩
export const JXJ2021_LUNBO = v1 + "/jxj2021/lunbo" // 用户任务历史


// 优质答主认证
export const XQA_USER_AGREE = v2 + "/xqa/user/agree" // 开通优质答主
export const ACTIVITY_QA_INFO = v1 + "/activity/qa-info" // 认证信息
export const ACTIVITY_QA_VERIFIED = v1 + "/activity/qa-verified" // 提交认证

// 身份认证
export const GET_USER_CERT = v2 + "/user/get-user-cert" // 认证结果
export const ADD_USER_CERT = v2 + "/user/add-user-cert" // 认证信息提交


// 2021一起自习活动
export const ROOM_WINTER_ROOM_RANK = v2 + "/room/winter-room-rank" // 排行榜
export const PLAN_STATISTICS_INFO = v2 + "/plan/statistics-info" // 个人战绩

//春节抓牛活动
export const ACTIVITY_SPRING_INDEX = v1 + "/activity/spring-index" // 首页用户基本信息
export const ACTIVITY_SPRING_AWARD = v1 + "/activity/spring-award" // 抽奖
export const ACTIVITY_SPRING_GIFT = v1 + "/activity/spring-gift" // 我的获奖列表
export const ACTIVITY_SPRING_RECORD = v1 + "/activity/spring-record" // 收货地址

//2023年周年庆
export const ANNIVERSARY_GIFT_LIST = v2 + "/anniversary2023/gift-list"//礼物列表
export const ANNIVERSARY_USER_GIFT_LIST = v2+ "/anniversary2023/user-gift-list"//用户礼物列表
export const ANNIVERSARY_RECEIVE_COUPON = v2+ "/anniversary2023/receive-coupon"//领取优惠券
export const ANNIVERSARY_USER_TOTAL_BOUND = v2+"/anniversary2023/user-total-bound" //用户领取红包金额
export const ANNIVERSARY_ADD_GIFT_ADDRESS = v2+"/anniversary2023/add-gift-address" //收获地址
export const ANNIVERSARY_RECEIVE_BONUS = v2+"/anniversary2023/receive-bonus"//领取红包
export const ANNIVERSARY_RAFFTE = v2+"/anniversary2023/raffte"//扭蛋机
export const ANNIVERSARY_GET_GIFT_ADDRESS=v2+"/anniversary2023/get-gift-address"//查看礼物地址
export const ANNIVERSARY_ALL_USER_RECORD = v2+"/anniversary2023/all-user-record"//所有用户抽奖记录
export const ANNIVERSARY_RAFFLE_QUALIFICATION = v2+"/anniversary2023/raffle-qualification" //用户抽奖剩余次数
export const ANNIVERSARY_USER_INVITATION_LIST = v2+"/user/invitation-list"//邀请用户list

//2024年周年庆
export const ANNIVERSARY_GIFT_LIST_2024 = v2 + "/anniversary2024/gift-list"//礼物列表
export const ANNIVERSARY_USER_GIFT_LIST_2024 = v2+ "/anniversary2024/user-gift-list"//用户礼物列表
export const ANNIVERSARY_RECEIVE_COUPON_2024 = v2+ "/anniversary2024/receive-coupon"//领取优惠券
export const ANNIVERSARY_USER_TOTAL_BOUND_2024 = v2+"/anniversary2024/user-total-bound" //用户领取红包金额
export const ANNIVERSARY_ADD_GIFT_ADDRESS_2024 = v2+"/anniversary2024/add-gift-address" //收获地址
export const ANNIVERSARY_RECEIVE_BONUS_2024 = v2+"/anniversary2024/receive-bonus"//领取红包
export const ANNIVERSARY_RAFFTE_2024 = v2+"/anniversary2024/raffte"//扭蛋机
export const ANNIVERSARY_GET_GIFT_ADDRESS_2024 = v2+"/anniversary2024/get-gift-address"//查看礼物地址
export const ANNIVERSARY_ALL_USER_RECORD_2024 = v2+"/anniversary2024/all-user-record"//所有用户抽奖记录
export const ANNIVERSARY_RAFFLE_QUALIFICATION_2024 = v2+"/anniversary2024/raffle-qualification" //用户抽奖剩余次数
export const ANNIVERSARY_STATISTICS_CLICCK = v2 + "/anniversary2024/statistics-click"



// 院校直播
export const COLLEGE_LIVE_LIST = v2 + "/vod/college-live/list" // 直播列表
export const COLLEGE_LIVE_SCHEDULE = v2 + "/vod/college-live/schedule" // 预约列表
export const COLLEGE_LIVE_HISTORY = v2 + "/vod/college-live/history" // 历史列表
export const COLLEGE_LIVE_DETAIL = v2 + "/vod/college-live/detail" // 详情
export const COLLEGE_LIVE_SCHEDULE_LOG = v2 + "/vod/live-schedule-log" // 预约上报
export const COLLEGE_LIVE_WATCH_LOG = v2 + "/vod/live-watch-log" // 观看历史上报
export const COLLEGE_LIVE_LIKE_COUNT = v2 + "/vod/live-like-count" // 点赞
export const COLLEGE_LIVE_COLLEGE_INFO = v2 + "/vod/college-live/college-info" // 院校信息
export const COLLEGE_LIVE_WENDA = v2 + "/circle/zy-college-bbs/post-index" // 招办问答
export const COLLEGE_LIVE_WENDA_CREATE = v2 + "/circle/zy-college-bbs/post-create" // 提交问答
export const COLLEGE_LIVE_NEWS = v2 + "/vod/college-live/college-news" // 招生动态
export const COLLEGE_LIVE_RAND = v2 + "/vod/college-live/rand" // 随机直播中或者其他直播
export const COLLEGE_HOT_LIVE = v2 + "/vod/college-live/college-hot-live" // 热门院校
export const COLLEGE_COLLEGE_PROMOTE = v2 + "/vod/college-live/college-promote" // 搜索院校推荐
export const COLLEGE_HAS_LIVE = v2 + "/vod/college-live/college-list-has-live" // 推荐直播院校
export const COLLEGE_COUNT_ADD = v2 + "/vod/live-share-count-add" // 分享统计
export const COLLEGE_SHARE_COUNT_ADD = v2 + "/vod/live-video-share-count-add" // 回放统计
export const COLLEGE_PREVIE_WATCH_COUNT = v2 + "/vod/live-previe-watch-count" // 预告片统计
export const COLLEGE_PREVIE_WATCH_DURATION = v2 + "/vod/live-user-watch-duration" // 观看时长统计

export const COLLEGE_LIVE_PROVINCE = v2 + "/vod/college-live/province-list-has-live" // 开通院校直播地区
export const COLLEGE_LIVE_PROJECT = v2 + "/vod/college-live/college-project-list" // 开通院校直播地区
export const COLLEGE_FORBID_MSG = v2 + "/vod/forbid-send-msg" // 群消息禁言
export const COLLEGE_DELETE_MSG = v2 + "/vod/group-msg-delete" // 群组删除消息
export const COLLEGE_ADD_REPORT = v2 + "/vod/college-live/add-report" // 举报请求


// vod直播相关，新增直播人数上报(每5s轮询，与原接口无关)
export const LIVE_KEEP_ALIVE = '/live/tim/keep-alive'


// 志愿 app7.0版本
export const WISH_PACKAGES = v2 + "/wish/wish-card-packages" // 志愿卡套餐
export const WISH_LIVE_MESSAGE = v2 + "/wish/leave-message" // 提交留言
export const WISH_INVITE_INFO = v2 + "/wish/invite-info" // 邀请收益
export const WISH_INVITE_UV = v2 + '/wish/invite-uv' // 志愿uv上报
export const WISH_INVITE_LIST = v2 + "/wish/invite-list" // 邀请记录
export const WISH_BUY_CARD_PRE = v2 + "/wish/buy-wish-card-pre" // 购买志愿卡
export const WISH_BUY_CARD_POST = v2 + "/wish/buy-wish-card-post" // 购买志愿卡之后
export const WISH_PAY_INFO = v2 + "/wish/pay-page-info" // 购买页信息
export const WISH_CARD_INDEX = v2 + "/wish/wish-card-html-index" // 落地页信息
export const WISH_CODE_TO_CARD = v2 + "/wish/code-to-card" // 落地页信息
export const WISH_CLICK_LOG = v2 + "/wish/click-log" // 新增人数

export const WISH_EVALUATE = v2 + "/wish-evaluate/add-or-up" // 添加或修改志愿评论
export const WISH_VOLUNTARY_LIST = v2 + "/wish-evaluate/list" // 评论列表


// 艺考志愿卡
export const YK_USER_INFO = v2 + "/wish-zy-art/zy-user-info" // 志愿卡用户信息
export const YK_CARD_PACKAGES = v2 + "/wish-zy-art/wish-card-packages" // 志愿卡套餐
export const YK_CARD_HTML_INDEX = v2 + "/wish-zy-art/wish-card-html-index" // 志愿卡落地页
export const YK_PAY_INFO = v2 + "/wish-zy-art/pay-page-info" // 志愿卡购买
export const YK_BUY_CARD_PRE = v2 + "/wish-zy-art/buy-wish-card-pre" // 志愿卡购买
export const YK_BUY_CARD_POST = v2 + "/wish-zy-art/buy-wish-card-post" // 购买校验
export const YK_BUY_CODE_TO_CARD = v2 + "/wish-zy-art/code-to-card" // 兑换艺考志愿卡

// 省市
export const APP_PROVINCE_LIST = v2 + "/app-manage/city/province-list" // 省市
export const APP_MIDDLESCHOOL = v2 + "/school/middleschool" // 中学


// 客服中心
export const SERVICE_QUESTION_LIST = v1 + "/zy-qa-gk/feedback-list2" // 常见问题列表
export const SERVICE_CONTACT_LIST = v1 + "/zy-qa-gk/user-feedback-list" // 对话流
export const SERVICE_UPLOAD_FILE = v1 + "/zy-qa-gk/file-upload" // 文件发送
export const SERVICE_SEND_MESSAGE = v1 + "/zy-qa-gk/feedback2" // 发送消息
export const SETTING_CONFIG_RICHTEXT = v1 + "/setting/config-richtext" // 富文本通用接口



// 车车代言人
export const SPOKESMAN_CONFIG = v1 + "/activity/spokesman-config" // 配置
export const SPOKESMAN_LIST = v1 + "/activity/spokesman-list" // 列表
export const SPOKESMAN_LIKE = v1 + "/activity/spokesman-like" // 点赞
export const SPOKESMAN_UPLOAD = v1 + "/activity/spokesman-upload" // 上传
export const SPOKESMAN_MY_LIST = v1 + "/activity/my-spokesman-list" // 我的上传
export const SPOKESMAN_TOP_LIST = v1 + "/activity/spokesman-top-list" // 代言人列表

// 高招机器人
export const GZ_ROBOT_COLLEGE_CONFIG = v2 + "/zy-bot/college-options" // 高招院校筛选配置
export const GZ_ROBOT_COLLEGE_LIST = v2 + "/zy-bot/college-list" // 高招院校列表
export const GZ_ROBOT_CHART = v2 + "/zy-bot/chat" // 聊天
export const GZ_ROBOT_INDEX = v2 + "/zy-bot/index" // 院校信息
export const GZ_ROBOT_FEEDBACK = v2 + "/zy-bot/feedback" // 留言
// 高招机器人 后台api
export const GZ_ROBOT_FEEDBACK_LIST = v2 + "/zy-bot/feedback-list" // 留言列表
export const GZ_ROBOT_CREAT_QA = v2 + "/zy-bot/create-qa" // 创建qa
export const GZ_ROBOT_UPDATE_QA = v2 + "/zy-bot/update-qa" // 更新qa


// 喊话我的未来大学
export const ASK_MESSAGE_LIST = v2 + "/circle/circle-card/activity-list" // 帖子列表
export const ASK_MESSAGE_CREATE = v2 + "/circle/circle-card/create" // 发布帖子
export const ASK_MESSAGE_DETAIL = v2 + "/circle/circle-card/view" // 帖子详情
export const ASK_MESSAGE_ADDLIKE = v2 + "/circle/circle-like/add-likecard" // 点赞帖子
export const ASK_MESSAGE_REMOVELIKE = v2 + "/circle/circle-like/remove-likecard" // 取消点赞

// 同学圈精华帖集锦活动
export const RECOMMEND_LIST = v2 + "/circle/circle-card/activity-list" // 帖子列表
export const RECOMMEND_TAGS = v2 + "/circle/circle-tag/hot-tags" // 热门帖tags

// 航海行动
export const SAILING_MISSION = v1 + "/sailing/mission"   //报名参加活动及任务列表
export const SAILING_GIFT = v1 + "/sailing/gift"   //兑换奖励
export const SAILING_GIFTLIST = v1 + "/sailing/gift-list"   //奖励列表
export const SAILING_DELETE_RECORD = v1 + "/sailing/delete-record" //删除航海活动记录

//辩论型投票
export const DEBATE_POLL_DETAIL = v2 + "/circle/circle-card/debate-poll-detail"   //辩论投票详情
export const DEBATE_POLL_COMMENT_LIST = v2 + "/circle/circle-comment/debate-poll-comment-list"   //辩论型投票评论列表
export const CIRCLE_COMMENT_ADD_COMMENT = v2 + "/circle/circle-comment/add-comment"   //新建辩论评论
export const ADD_LEKECOMMENT = v2 + "/circle/circle-like/add-likecomment"   //点赞评论
export const REMOVE_LEKECOMMENT = v2 + "/circle/circle-like/remove-likecomment"   //取消点赞评论
export const VOTE = v2 + "/circle/circle-card/vote"   //投票

//电子版学霸笔记
export const XUEBA_NOTE_LIST = v2 + "/xueba-note/list"   //笔记列表
export const XUEBA_NOTE_CATEGORY = v2 + "/xueba-note/category"   //笔记分类
export const XUEBA_NOTE_PAY = v2 + "/xueba-note/pay"   //笔记支付
export const XUEBA_NOTE_AFTER_PAY = v2 + "/xueba-note/after-pay"   //笔记支付后查询
export const XUEBA_NOTE_USER_LIST = v2 + "/xueba-note/user-list"   //我的笔记
export const XUEBA_NOTE_NOTE = v2 + "/xueba-note/note"   //笔记详情

//人设活动
export const UPDATE_WBUSER_HEADWEAR = v1 + "/activity/update-wbuser-headwear"   //头饰更新

//心愿红包活动
export const WISHRED_INDEX = v2 + "/wishred/index"   //活动主页
export const WISHRED_CREATE_RED_WISH = v2 + "/wishred/create-red-wish"   //添加心愿
export const WISHRED_LIGHT_ON = v2 + "/wishred/light-on"   //点灯
export const WISHRED_HELPED_LOGS = v2 + "/wishred/helped-logs"   //日志列表
export const WISHRED_HELPED_INDEX = v2 + "/wishred/light-index"   //个人心愿灯主页
export const WISHRED_OPEN_INDEX = v2 + "/wishred/open-index"   //红包开奖主页
export const WISHRED_OPEN_PAPER = v2 + "/wishred/open-paper"   //红包开启

// 2022-百日誓师
export const PLEDGE2022_USER = v2 + "/pledge/user" // 誓师用户信息
export const PLEDGE2022_PRIZE_LOGS = v2 + "/pledge/prize-logs" // 中奖记录
export const PLEDGE2022_LUCK_DRAW = v2 + "/pledge/lucky-draw" // 抽奖
export const PLEDGE2022_USIGN = v1 + "/service-pledge2022/usign" // 腾讯云上传签名
export const PLEDGE2022_CREATE = v1 + "/service-pledge2022/create" // 创建
export const PLEDGE2022_SAVEFILE = v1 + "/service-pledge2022/savefile" // 保存图片
export const PLEDGE2022_CARD = v1 + "/service-pledge2022/card" // 查看帖子详情
export const PLEDGE2022_INDEX = v1 + "/service-pledge2022/index"   //首页
export const PLEDGE2022_COLLEGERANK = v1 + "/service-pledge2022/college-rank" // 高校排行列表
export const PLEDGE2022_CUEWORD = v1 + "/service-pledge2021/cue-word" // 院校名称提示词
export const PLEDGE2022_LIST = v1 + "/service-pledge2022/list" // 宣誓团列表
export const PLEDGE2022_LIKE = v1 + "/service-pledge2022/like" // 点赞
export const PLEDGE2022_LUNBO = v1 + "/service-pledge2022/lunbo" // 轮播
export const PLEDGE2022_MEDIA_LIST = v1 + "/service-pledge2021/media-list" // 语音列表
export const PLEDGE2022_UPLOAD_MEDIA = v1 + "/service-pledge2021/upload-media" // 语音上传
export const PLEDGE2022_USER_LIST = v1 + "/service-pledge2022/user-list" // 用户发帖记录
export const PLEDGE2022_USER_PROFILE = v1 + "/service-pledge2022/user-profile" // 填写收货地址
export const PLEDGE2022_ENERGY = v1 + "/service-pledge2022/energy" // 获取鼓励值

// 学考抽奖
export const XUEKAO_LOTTERY_INFO = v2 + "/xuekao-zt/lottery-info" // 抽奖信息
export const XUEKAO_LOTTERY_LOGS = v2 + "/xuekao-zt/lottery-logs" // 抽奖记录
export const XUEKAO_LOTTERY_PRIZES = v2 + "/xuekao-zt/lottery-prizes" // 我的奖品
export const XUEKAO_LOTTERY_PRIZE_INFO = v2 + "/xuekao-zt/lottery-prize-info" // 奖品兑奖信息填写
export const XUEKAO_LOTTERY_LUCKY_DRAW = v2 + "/xuekao-zt/lucky-draw" // 抽奖
export const XUEKAO_LOTTERY_INDEX_PRIZES = v2 + "/xuekao-zt/index-prizes" // 滚动抽奖信息
export const XUEKAO_LOTTERY_SHARE_PRIZE = v2 + "/xuekao-zt/share-prize" // 分享加次数

// 上传图片
export const PAPER_UPLOAD_PIC = v2 + "/paper/upload-pic" // 上传图片
export const PAPER_UPLOAD_PAPER = v2 + "/paper/upload-paper" // 创建试题
export const GET_UPLOAD_QR_INDO = v2 + "/paper/get-upload-qr-info" // 创建试题
export const NEW_INFO_OMNI_SUGGEST = v2 + "/news-info/omni-suggest" // 创建试题


// 市排名转换省排名
export const ESTI_POST_EXAM_USER = v2 + "/esti/post-exam-user" // 滚动抽奖信息
export const ESTI_EXAM_USER = v2 + "/esti/exam-user" // 创建试题
export const ESTI_FSD = v2 + "/esti/fsd" // 创建试题

// 10周年庆

// 广州一模
export const YM_GET_USER_INFO = v2 + "/gdym/get-user-info" // 获取用户信息
export const YM_POST_USER_INFO = apiUrl + v2 + "/gdym/post-user-base" // 提交用户信息
export const YM_POST_USER_COURSE = apiUrl + v2 + "/gdym/post-user-course" // 提交科目信息
export const YM_CITY = apiUrl + v2 + "/gdym/cities" // 城市列表
export const YM_NEWS = v2 + '/news-info/news-list' // 获取新闻
export const YM_BUY_CARD = v2 + "/gdym/buy-card-pre" // 提交订单
export const YM_CARD_LOGS = v2 + "/gdym/card-logs" // 购买记录
export const YM_CARD_POST = v2 + "/gdym/buy-card-post" // 支付后请求
export const YM_GET_PC = v2 + "/gdym/get-pc" // 获取批次
export const YM_FSD_SCORE = v2 + "/gdym/get-fsd-official" // 一分一段查询
export const YM_REPORT = v2 + "/gdym/report" // 报告数据
export const YM_REPORT_FSD = v2 + "/wish-zy-cors/fsd-score" // 报告的一分一段列表
export const YM_BUY_CARD_POST = v2 + "/gdym/buy-card-post" // 报告的一分一段列表
export const YM_SCHOOL_SCREACH = v2 + "/school/college" // 院校查询
export const YM_SCHOOL_SET = v2 + "/user/set-ideal-college" // 设置理想高校
export const YM_TARGET_SCHOOL = v2 + "/gdym/my-target-school" // 我的目标院校
export const YM_ORI_LEVEL = v2 + "/gdym/ori-level" // 原始分转换

// 福建质检
export const FJYM_GET_USER_INFO = v2 + "/fjym/get-user-info" // 获取用户信息
export const FJYM_POST_USER_INFO = apiUrl + v2 + "/fjym/post-user-base" // 提交用户信息
export const FJYM_POST_USER_COURSE = v2 + "/fjym/post-user-course" // 提交科目信息

export const FJYM_CITY = apiUrl + v2 + "/fjym/cities" // 城市列表
export const FJYM_NEWS = v2 + '/news-info/news-list' // 获取新闻
export const FJYM_BUY_CARD = v2 + "/fjym/buy-card-pre" // 提交订单
export const FJYM_CARD_LOGS = v2 + "/fjym/card-logs" // 购买记录
export const FJYM_CARD_POST = v2 + "/fjym/buy-card-post" // 支付后请求
export const FJYM_GET_PC = v2 + "/fjym/get-pc" // 获取批次
export const FJYM_FSD_SCORE = v2 + "/fjym/get-fsd-official" // 一分一段查询
export const FJYM_REPORT = v2 + "/fjym/report" // 报告数据
export const FJYM_REPORT_FSD = v2 + "/wish-zy-cors/fsd-score" // 报告的一分一段列表
export const FJYM_BUY_CARD_POST = v2 + "/fjym/buy-card-post" // 报告的一分一段列表
export const FJYM_SCHOOL_SCREACH = v2 + "/school/college" // 院校查询
export const FJYM_SCHOOL_SET = v2 + "/user/set-ideal-college" // 设置理想高校
export const FJYM_TARGET_SCHOOL = v2 + "/fjym/my-target-school" // 我的目标院校
export const FJYM_ORI_LEVEL = v2 + "/fjym/ori-level" // 原始分转换
export const USER_PHONE = v2 + "/user/user-mobile" // 原始分转换

// 旧高考转换工具 模板
export const REPORT_FSD = v2 + "/wish-zy-cors/fsd-score" // 报告的一分一段列表
export const SCHOOL_SCREACH = v2 + "/school/college" // 院校查询
export const SCHOOL_SET = v2 + "/user/set-ideal-college" // 设置理想高校

export const GKMOCK_GET_USER_INFO = v2 + "/gkmock/get-user-info" // 获取用户信息
export const GKMOCK_POST_USER_INFO = apiUrl + v2 + "/gkmock/post-user-base" // 提交用户信息
export const GKMOCK_POST_USER_COURSE = apiUrl + v2 + "/gkmock/post-user-course" // 提交科目信息
export const GKMOCK_CITY = apiUrl + v2 + "/gkmock/cities" // 城市列表
export const GKMOCK_NEWS = v2 + '/news-info/news-list' // 获取新闻
export const GKMOCK_BUY_CARD = v2 + "/gkmock/buy-card-pre" // 提交订单
export const GKMOCK_CARD_LOGS = v2 + "/gkmock/card-logs" // 购买记录
export const GKMOCK_CARD_POST = v2 + "/gkmock/buy-card-post" // 支付后请求
export const GKMOCK_GET_PC = v2 + "/gkmock/get-pc" // 获取批次
export const GKMOCK_FSD_SCORE = v2 + "/gkmock/get-fsd-official" // 一分一段查询
export const GKMOCK_REPORT = v2 + "/gkmock/report" // 报告数据
export const GKMOCK_BUY_CARD_POST = v2 + "/gkmock/buy-card-post" // 报告的一分一段列表
export const GKMOCK_TARGET_SCHOOL = v2 + "/gkmock/my-target-school" // 我的目标院校
export const GKMOCK_ORI_LEVEL = v2 + "/gkmock/ori-level" // 原始分转换
export const GKMOCK_GARD_INFO = v2 + '/gkmock/card-info' // 考试详情
export const GKMOCK_GARD_LIST = v2 + '/gkmock/card-list' // 考试列表
export const GKMOCK_PROVINCE_LINE = v2 + '/gkmock/mock-province-line' // 模考批次线
export const GKMOCK_CARD_GIVING = v2 + '/gkmock/card-giving' // 模考批次线


// 估分活动
export const GUESS_RESULT = v2 + "/guess-score/guess-result" // 预测结果
export const GUESS_HISTORY = v2 + "/guess-score/guess-history" // 预测记录
export const MY_GUESS = apiUrl + v2 + "/guess-score/my-guess" // 我的预测
export const SUMBIT_GUESS = v2 + "/guess-score/submit-guess" // 提交预测
export const GET_SHARE = v2 + "/guess-score/get-share" // 分享
export const GET_COUPON = v2 + "/guess-score/gen-coupons" // 分享

// 晒志愿排行榜
export const COLLEGE_HOT_RANK = v2 + "/college-hot-rank/provice-type" // 城市分类
export const MY_COLLEGE = apiUrl + v2 + "/college-hot-rank/my-college" // 我的院校
export const COLLEGE_DETAIL = v2 + "/college-hot-rank/college-detail" // 院校详情
export const ADD_SCORE = v2 + '/college-hot-rank/add-score' // 提交分数
export const ADD_COLLEGE = v2 + '/college-hot-rank/add-college' // 提交学校
export const COLLEGE_RANK = v2 + '/college-hot-rank/all-college-rank' // 院校排行
export const COLLEGE_SHARE = v2 + '/college-hot-rank/college-share' // 分享

// 春考志愿排行榜
export const XK_MY_COLLEGE = v2 + "/college-hot-rank/chunji-my-college" // 我的院校
export const XK_COLLEGE_DETAIL = v2 + "/college-hot-rank/chunji-college-detail" // 院校详情
export const XK_ADD_SCORE = v2 + '/college-hot-rank/chunji-add-score' // 提交分数
export const XK_ADD_COLLEGE = v2 + '/college-hot-rank/chunji-add-college' // 提交学校
export const XK_COLLEGE_RANK = v2 + '/college-hot-rank/chunji-all-college-rank' // 院校排行
export const XK_COLLEGE_SHARE = v2 + '/college-hot-rank/chunji-college-share' // 分享
export const XK_COLLEGE_SEARCH = v2 + '/college-hot-rank/college' // 搜索院校


// 志愿2022落地页
export const ZY2022_COUPON = v2 + '/college-hot-rank/all-coupon-states' //
export const GET_COUPON2 = v2 + '/guess-score/gen-coupons2' //


// 复读调查
export const DIAOCHA_DIAOCHA = v1 + '/diaocha/diaocha' // 提交
export const DIAOCHA_INFO = v1 + '/diaocha/info' // 详情
export const DIAOCHA_SHARE = v1 + '/diaocha/share' // 分享

// 复读专题
export const REREAD_SUB = v2 + '/reread/cre-reread-sub' // 提交
export const REREAD_LIST = v2 + '/reread/get-reread-schools' // 列表
export const REREAD_DETAIL = v2 + '/reread/get-reread-school-detail' // 详情
// 新志愿卡活动
export const LOTTERY_SPRING_INDEX = v1 + "/lottery202207/spring-index" // 首页用户基本信息
export const LOTTERY_SPRING_AWARD = v1 + "/lottery202207/spring-award" // 抽奖
export const LOTTERY_SPRING_GIFT = v1 + "/lottery202207/spring-gift" // 我的获奖列表
export const LOTTERY_SPRING_RECORD = v1 + "/lottery202207/spring-record" // 收货地址

// 新志愿卡活动
export const GET_RANDOM_ROOM = v2 + "/room/get-random-room" // 获取随机的自习室
export const GET_RANDOM_NOTIFY_NOW = v2 + "/room/get-room-notify-now" // 实时展示加入自习室动态
export const ROOM_INDEX = v2 + '/room/summer-vacation-room-index' // 首页
export const ROOM_START = v2 + '/room/start-summer-vaction-room' // 开启挑战
export const ROOM_JOIN = v2 + '/room/join' // 口令返回群号

// 青桐鸣
export const QTM_EXAM_LIST = v2 + '/qtm/exam-list' // 考试列表
export const QTM_USED_CODE = v2 + '/qtm/used-code' // 绑定cdkey
export const QTM_CODE_LIST = v2 + '/qtm/user-code-list' // 激活列表
export const QTM_INDEX = v2 + '/qtm/qtm-index' // 首页以及一些用户信息
export const QTM_GKYC = v2 + '/qtm/gkyc' // 首页
export const QTM_FORECAST = v2 + '/qtm/qtm-forecast-score' // 首页
export const QTM_FORECAST_SUBJECT = v2 + '/qtm/qtm-forecast-score-subject' // 首页
export const QTM_TARGET_COLLEGE = v2 + '/qtm/get-target-college' // 目标院校

// 学考在线题库 xgk接口
export const EXAM_INDEX = '/exam/new-exam/index'  //学考题库首页
export const EXAM_ANT_CATE = '/exam/new-exam/get-province-and-cate' //学考题库首页省份和科目信息
export const EXAM_SET_PROVINCE_CATE = '/exam/new-exam/set-province-and-cate'  //设置省份和科目
export const EXAM_PUNCH_INDEX = '/exam/new-exam/punch-index'  //打卡首页
export const EXAM_PUNCH_RANK = '/exam/new-exam/punch-rank' //打卡排行榜
export const EXAM_PUNCH_HISTORY = '/exam/new-exam/punch-history' //  打卡历史记录
export const EXAM_HISTORY = '/exam/new-exam/practise-history' //练习记录
export const EXAM_PUNCH_ANSWERRANK = '/exam/new-exam/get-rank'  //答题排行榜
export const EXAM_ZHENTI = '/exam/new-exam/get-zhenti-list'  //真题列表
export const EXAM_GET_MISORCOL = '/exam/new-exam/get-mistake-or-collect'  //获取收藏或者错题集
export const EXAM_GET_JXLX = '/exam/new-exam/get-jxlx'  //获取收藏或者错题集
export const EXAM_POST_MISTAKE = '/exam/new-exam/del-mistake-or-collect'  //删除错题，取消收藏
export const EXAM_PAPER_ITEMS = '/exam/new-exam/paper-items' // 试题详情
export const EXAM_PAPER_COLLECT = '/exam/new-exam/add-collect' // 试题收藏
export const EXAM_PAPER_DEL_COLLECT = '/exam/new-exam/del-mistake-or-collect' // 试题取消收藏 或者 删除错题
export const EXAM_PAPER_REPORT_ERROR = '/exam/new-exam/report-error' // 报错
export const EXAM_GET_NEXT = '/exam/new-exam/get-next-20' // 顺序练习获得下面20道题1
export const EXAM_COMPUTE = '/exam/new-exam/compute' // 提交打卡/练习
export const EXAM_COMPUTE_SHITI = '/exam/new-exam/shiti-compute' // 提交真题
export const EXAM_RESULT = '/exam/new-exam/practise-res' // 练习结果展示
export const EXAM_TEST = '/exam/exam/test-token'

export const EXAM_USER_INFO = '/exam/new-exam/get-use-time-info' // 首页获取用户时间信息
export const EXAM_DEL_TIME = '/exam/new-exam/del-time' // 消耗时间
export const EXAM_SHARE = '/exam/new-exam/share-xktk' // 分享学考题库
export const EXAM_ADD_NEW = '/exam/new-exam/add-new-time' // 领取新人礼包
export const EXAM_TIME_HISTORY = '/exam/new-exam/get-time-history' // 获取历史记录时间

// 新版预取预估报告
export const GKMOCK_USER_INFO = v2 + '/gkmock/get-user-info2' // 用户信息2
export const GKMOCK_CARD_LIST = v2 + '/gkmock/card-list' // 模考列表
export const GKMOCK_CARD_LOGS2 = v2 + '/gkmock/card-logs2' // 预估记录v2
export const GKMOCK_CARD_LIST2 = apiUrl + v2 + '/gkmock/card-list2' // 模考列表2
export const GKMOCK_REPORT2 = v2 + "/gkmock/report2" // 报告数据v2
export const GKMOCK_TARGET_SCHOOL2 = v2 + "/gkmock/my-target-school2" // 报告数据v2
export const GKMOCK_CARD_INFO2 = v2 + "/gkmock/card-info2" // 模考服务卡的基础信息_增加返回省无限卡
export const GKMOCK_CARD_INFO3 = v2 + "/gkmock/card-info3" // 返回无限卡列表
export const GKMOCK_PV = apiUrl + v2 + "/gkmock/pv" // 模考点击事件记录
export const GKMOCK_COUPON = apiUrl + v2 + "/gkmock/receive-coupon" // 领取优惠券

export const GKMOCK_WISH_BUY_CARD = v2 + "/gkmock/wish-and-mock-buy-card-pre" // 提交订单_混合套餐
export const GKMOCK_WISH_BUY_CARD_POST = v2 + "/gkmock/wish-and-mock-buy-card-post" // 支付后请求_混合套餐

export const GKMOCK_OCCUPATION_RECOMMEND = v2 + "/gkmock/occupation-recommend" // 模考报告推荐职业
export const GKMOCK_GET_FSD_OFFICIAL = v2 + "/gkmock/get-fsd-official" // 模考报告推荐职业




// 积分任务
export const NY2023_TASK = v2 + '/credit/task'
export const NY2023_TASK_SHARE = v1 + '/spring2023/task-done'
export const NY2023_DRAW = v1 + '/spring2023/spring-award'

// 2023元旦活动-许愿部分
export const NY2023_WISH_LIST = v1 + '/spring2023/wish-list'  //我的心愿列表
export const NY2023_WISH_POST = v1 + '/spring2023/wish-post'  //提交心愿
export const NY2023_FREE_ORDER = v1 + '/spring2023/free-order'  //免单详情
export const NY2023_ORDER_POST = v1 + '/spring2023/order-post'  //提交免单
export const NY2023_GIFT_LIST = v1 + '/spring2023/spring-gift'
export const NY2023_GIFT_RECORD = v1 + '/spring2023/spring-record'

// 2024元旦活动
export const NY2024_WISH_LIST = v1 + '/spring2024/wish-list'  //我的心愿列表
export const NY2024_WISH_POST = v1 + '/spring2024/wish-post'  //提交心愿
export const NY2024_FREE_ORDER = v1 + '/spring2024/free-order'  //免单详情
export const NY2024_ORDER_POST = v1 + '/spring2024/order-post'  //提交免单
export const NY2024_GIFT_LIST = v1 + '/spring2024/spring-gift'
export const NY2024_GIFT_RECORD = v1 + '/spring2024/spring-record'

// 学考讨论圈（试题众筹）xgk接口
export const DISCUSS_LIST = '/exam/discuss/list' // 列表
export const DISCUSS_DETAIL = '/exam/discuss/detail' // 详情
export const DISCUSS_UPLOAD = '/exam/discuss/upload-img' // 上传图片
export const DISCUSS_GET_CATE = '/exam/discuss/get-all-cate' // 获取所有学科
export const DISCUSS_COMMENT_LIST = '/exam/discuss/comment-list' // 评论列表
export const DISCUSS_ANSWER = '/exam/discuss/add-answer' // 添加答案
export const DISCUSS_STATISTICS = '/exam/discuss/get-user-answer-and-statistics' // 统计信息
export const DISCUSS_COMMENT = '/exam/discuss/add-comment' // 评论
export const DISCUSS_LIKE = '/exam/discuss/like' // 点赞
export const DISCUSS_DISLIKE = '/exam/discuss/dislike' // 取消点赞
export const DISCUSS_MYCOMMENT = '/exam/discuss/my-comment' // 获取我的评论
export const DISCUSS_DELETE = '/exam/discuss/del-comment' // 删除评论

// 2023新年红包活动
export const WISHRED2023_INDEX = v2 + "/wishred2023/index"   //活动主页
export const WISHRED2023_CREATE_RED_WISH = v2 + "/wishred2023/create-red-wish"   //添加心愿
export const WISHRED2023_LIGHT_ON = v2 + "/wishred2023/light-on"   //点灯
export const WISHRED2023_HELPED_LOGS = v2 + "/wishred2023/helped-logs"   //日志列表
export const WISHRED2023_HELPED_INDEX = v2 + "/wishred2023/light-index"   //个人心愿灯主页
export const WISHRED2023_OPEN_INDEX = v2 + "/wishred2023/open-index"   //红包开奖主页
export const WISHRED2023_OPEN_PAPER = v2 + "/wishred2023/open-paper"   //红包开启

// 春季高考估分
export const CHUNJI_GKGF_LIST = '/exam/new-exam/chunji-gkgf-list' // 首页
export const CHUNJI_GKGF_USER = '/exam/new-exam/chunji-gkgf-user' // 估分用户
export const CHUNJI_GKGF_RANK = '/exam/new-exam/chunji-gkgf-ranking' // 排行榜
export const CHUNJI_GKGF_REPORT = '/exam/new-exam/chunji-gkgf-report' // 估分报告

// 2023-百日誓师
export const PLEDGE2023_USER = v2 + "/pledge/user" // 誓师用户信息
export const PLEDGE2023_PRIZE_LOGS = v1 + "/service-pledge2023/prize-logs" // 中奖记录
export const PLEDGE2023_LUCK_DRAW = v1 + "/service-pledge2023/lucky-draw" // 抽奖
export const PLEDGE2023_USIGN = v1 + "/service-pledge2023/usign" // 腾讯云上传签名
export const PLEDGE2023_CREATE = v1 + "/service-pledge2023/create" // 创建
export const PLEDGE2023_SAVEFILE = v1 + "/service-pledge2023/savefile" // 保存图片
export const PLEDGE2023_CARD = v1 + "/service-pledge2023/card" // 查看帖子详情
export const PLEDGE2023_INDEX = v1 + "/service-pledge2023/index"   //首页
export const PLEDGE2023_COLLEGERANK = v1 + "/service-pledge2023/college-rank" // 高校排行列表
export const PLEDGE2023_CUEWORD = v1 + "/service-pledge2021/cue-word" // 院校名称提示词
export const PLEDGE2023_LIST = v1 + "/service-pledge2023/list" // 宣誓团列表
export const PLEDGE2023_LIKE = v1 + "/service-pledge2023/like" // 点赞
export const PLEDGE2023_DISLIKE = v1 + "/service-pledge2023/dis-like" // 取消点赞
export const PLEDGE2023_LUNBO = v1 + "/service-pledge2023/lunbo" // 轮播
export const PLEDGE2023_MEDIA_LIST = v1 + "/service-pledge2021/media-list" // 语音列表
export const PLEDGE2023_UPLOAD_MEDIA = v1 + "/service-pledge2021/upload-media" // 语音上传
export const PLEDGE2023_USER_LIST = v1 + "/service-pledge2023/user-list" // 用户发帖记录
export const PLEDGE2023_USER_PROFILE = v1 + "/service-pledge2023/user-profile" // 填写收货地址
export const PLEDGE2023_ENERGY = v1 + "/service-pledge2023/energy" // 获取鼓励值
export const PLEDGE2023_FOLLOW = v2 + "/user-index/follow" // 关注/取消关注
export const PLEDGE2023_ADD_SHARE = v1 +  '/service-pledge2023/add-share' // 获得抽奖机会
export const PLEDGE2023_RANDOM_PLEDGE = v1 + '/service-pledge2023/random-pledge' // 获取随机学霸寄语
export const PLEDGE2023_SHARELIST = v1 + "/service-pledge2023/get-share-list" // 关注/取消关注
export const PLEDGE2023_LOG = v1 + "/service-pledge2023/all-prize-logs" // 关注/取消关注

// 2024-百日誓师
export const PLEDGE2024_USER = v2 + "/pledge/user" // 誓师用户信息
export const PLEDGE2024_PRIZE_LOGS = v1 + "/service-pledge2024/prize-logs" // 中奖记录
export const PLEDGE2024_LUCK_DRAW = v1 + "/service-pledge2024/lucky-draw" // 抽奖
export const PLEDGE2024_USIGN = v1 + "/service-pledge2024/usign" // 腾讯云上传签名
export const PLEDGE2024_CREATE = v1 + "/service-pledge2024/create" // 创建
export const PLEDGE2024_SAVEFILE = v1 + "/service-pledge2024/savefile" // 保存图片
export const PLEDGE2024_CARD = v1 + "/service-pledge2024/card" // 查看帖子详情
export const PLEDGE2024_INDEX = v1 + "/service-pledge2024/index"   //首页
export const PLEDGE2024_COLLEGERANK = v1 + "/service-pledge2024/college-rank" // 高校排行列表
export const PLEDGE2024_CUEWORD = v1 + "/service-pledge2024/cue-word" // 院校名称提示词
export const PLEDGE2024_LIST = v1 + "/service-pledge2024/list" // 宣誓团列表
export const PLEDGE2024_LIKE = v1 + "/service-pledge2024/like" // 点赞
export const PLEDGE2024_DISLIKE = v1 + "/service-pledge2024/dis-like" // 取消点赞
export const PLEDGE2024_LUNBO = v1 + "/service-pledge2024/lunbo" // 轮播
export const PLEDGE2024_USER_LIST = v1 + "/service-pledge2024/user-list" // 用户发帖记录
export const PLEDGE2024_USER_PROFILE = v1 + "/service-pledge2024/user-profile" // 填写收货地址
export const PLEDGE2024_FOLLOW = v2 + "/user-index/follow" // 关注/取消关注
export const PLEDGE2024_ADD_SHARE = v1 +  '/service-pledge2024/add-share' // 获得抽奖机会
export const PLEDGE2024_RANDOM_PLEDGE = v1 + '/service-pledge2024/random-pledge' // 获取随机学霸寄语
export const PLEDGE2024_SHARELIST = v1 + "/service-pledge2024/get-share-list" // 关注/取消关注
export const PLEDGE2024_LOG = v1 + "/service-pledge2024/all-prize-logs" // 关注/取消关注

// 2026-百日誓师
export const PLEDGE2025_USER = v2 + "/pledge/user" // 誓师用户信息
export const PLEDGE2025_PRIZE_LOGS = v1 + "/service-pledge2025/prize-logs" // 中奖记录
export const PLEDGE2025_LUCK_DRAW = v1 + "/service-pledge2025/lucky-draw" // 抽奖
export const PLEDGE2025_USIGN = v1 + "/service-pledge2025/usign" // 腾讯云上传签名
export const PLEDGE2025_CREATE = v1 + "/service-pledge2025/create" // 创建
export const PLEDGE2025_SAVEFILE = v1 + "/service-pledge2025/savefile" // 保存图片
export const PLEDGE2025_CARD = v1 + "/service-pledge2025/card" // 查看帖子详情
export const PLEDGE2025_INDEX = v1 + "/service-pledge2025/index"   //首页
export const PLEDGE2025_COLLEGERANK = v1 + "/service-pledge2025/college-rank" // 高校排行列表
export const PLEDGE2025_CUEWORD = v1 + "/service-pledge2025/cue-word" // 院校名称提示词
export const PLEDGE2025_LIST = v1 + "/service-pledge2025/list" // 宣誓团列表
export const PLEDGE2025_LIKE = v1 + "/service-pledge2025/like" // 点赞
export const PLEDGE2025_DISLIKE = v1 + "/service-pledge2025/dis-like" // 取消点赞
export const PLEDGE2025_LUNBO = v1 + "/service-pledge2025/lunbo" // 轮播
export const PLEDGE2025_USER_LIST = v1 + "/service-pledge2025/user-list" // 用户发帖记录
export const PLEDGE2025_USER_PROFILE = v1 + "/service-pledge2025/user-profile" // 填写收货地址
export const PLEDGE2025_FOLLOW = v2 + "/user-index/follow" // 关注/取消关注
export const PLEDGE2025_ADD_SHARE = v1 +  '/service-pledge2025/add-share' // 获得抽奖机会
export const PLEDGE2025_RANDOM_PLEDGE = v1 + '/service-pledge2025/random-pledge' // 获取随机学霸寄语
export const PLEDGE2025_SHARELIST = v1 + "/service-pledge2025/get-share-list" // 关注/取消关注
export const PLEDGE2025_LOG = v1 + "/service-pledge2025/all-prize-logs" // 关注/取消关注

export const PLEDGE2025_LIVE_LIST = v1 + "/service-pledge2025/live-list" //誓师现场
export const PLEDGE2025_SCHOOL_SEARCH = v1 + "/service-pledge2025/school-search" //誓师现场
export const PLEDGE2025_GET_AWARD = v1 + "/service-pledge2025/get-award" //誓师现场

// 202x-百日誓师
export const PLEDGE_USER = v2 + "/pledge/user" // 誓师用户信息
export const PLEDGE_PRIZE_LOGS = v1 + "/service-pledge/prize-logs" // 中奖记录
export const PLEDGE_LUCK_DRAW = v1 + "/service-pledge/lucky-draw" // 抽奖
export const PLEDGE_USIGN = v1 + "/service-pledge/usign" // 腾讯云上传签名
export const PLEDGE_CREATE = v1 + "/service-pledge/create" // 创建
export const PLEDGE_SAVEFILE = v1 + "/service-pledge/savefile" // 保存图片
export const PLEDGE_CARD = v1 + "/service-pledge/card" // 查看帖子详情
export const PLEDGE_INDEX = v1 + "/service-pledge/index"   //首页
export const PLEDGE_COLLEGERANK = v1 + "/service-pledge/college-rank" // 高校排行列表
export const PLEDGE_CUEWORD = v1 + "/service-pledge/cue-word" // 院校名称提示词
export const PLEDGE_LIST = v1 + "/service-pledge/list" // 宣誓团列表
export const PLEDGE_LIKE = v1 + "/service-pledge/like" // 点赞
export const PLEDGE_DISLIKE = v1 + "/service-pledge/dis-like" // 取消点赞
export const PLEDGE_LUNBO = v1 + "/service-pledge/lunbo" // 轮播
export const PLEDGE_USER_LIST = v1 + "/service-pledge/user-list" // 用户发帖记录
export const PLEDGE_USER_PROFILE = v1 + "/service-pledge/user-profile" // 填写收货地址
export const PLEDGE_FOLLOW = v2 + "/user-index/follow" // 关注/取消关注
export const PLEDGE_ADD_SHARE = v1 +  '/service-pledge/add-share' // 获得抽奖机会
export const PLEDGE_RANDOM_PLEDGE = v1 + '/service-pledge/random-pledge' // 获取随机学霸寄语
export const PLEDGE_SHARELIST = v1 + "/service-pledge/get-share-list" // 关注/取消关注
export const PLEDGE_LOG = v1 + "/service-pledge/all-prize-logs" // 关注/取消关注

export const PLEDGE_LIVE_LIST = v1 + "/service-pledge/live-list" //誓师现场
export const PLEDGE_SCHOOL_SEARCH = v1 + "/service-pledge/school-search" //誓师现场
export const PLEDGE_GET_AWARD = v1 + "/service-pledge/get-award" //誓师现场

// 渠道商接口
export const WISH_BUY_CARD_PRE_CHANNEL = v2 + "/wish/buy-wish-card-pre-channel" // 购买志愿卡 - 渠道商
export const WISH_CARD_PACKAGES_CHANNEL = v2 + "/wish/ch-card-packages" // 志愿卡套餐 - 渠道商
export const WISH_CHANNEL_LOG = v2 + "/wish/channel-scan-log-up" // 登录回调记录uv - 渠道商

export const SEARCH_MIDDLESCHOOL = v2 + "/school/middleschool-byname" // 搜索中学列表
export const SEARCH_MIDDLESCHOOL_CITY = v2 + "/school/middleschool-byname-first-province" // 搜索中学列表，优先限制省份


// 完成积分任务
export const CREDIT_DOWN = v2 + '/credit2/done'

// 机构合作
export const RECRUIT_ORGANIZATION_CONFIG = v1 + '/service-organization/organization-config'
export const RECRUIT_EDIT_COOPERATE = v1 + '/service-organization/add-or-up-cooperate' // 新增/编辑我要合作
export const RECRUIT_VIEW_COOPERATE = v1 + '/service-organization/view-cooperate' // 查看合作
export const RECRUIT_TYPE_LIST = v1 + '/service-organization/type-list' // 获取机构类型列表
export const RECRUIT_VIEW_TYPE = v1 + '/service-organization/view-type' // 机构类型详情
export const RECRUIT_ORGANIZATION_LIST = v1 + '/service-organization/organization-list' // 获取机构列表
export const RECRUIT_EDIT_RESERVE = v1 + '/service-organization/add-or-up-reserve' // 创建或者更新预约
export const RECRUIT_VIEW_ORGANIZATION = v1 + '/service-organization/view-organization' // 获取机构详情
export const RECRUIT_RESERVE_LIST = v1 + '/service-organization/reserve-list' // 我的预约
export const RECRUIT_PROVINCE_LIST = v1 + '/service-organization/province-list' // 省份列表
export const RECRUIT_UPLOAD = v1 + '/order/upload-pic'

//高考数据报告
export const DATA_REPORT_VIEW = v2 + "/data-report/view" // 报告详情
export const DATA_REPORT_INFO = v2 + "/data-report/data-report-info" // 报告详情
export const DATA_REPORT_BUY = v2 + "/data-report//buy-data-report-pre" // 购买数据报告 订单
export const DATA_REPORT_POST = v2 + "/data-report/buy-data-report-post" // 支付后请求

// 高考录取指南
export const GKLQZN_NEWS_MERG = apiUrl + v2 + "/gklqzn/news-merge" // 时间轴
// app志愿相关接口
export const WISH_ZY_FORM_CONFIG = v2 + '/wish-zy/form-config' // 成绩提交时省份列表 + 详情
export const WISH_ZY_SUBMIT_SCORE = v2 + '/wish-zy/submit-score' // 提交成绩
export const WISH_ZY_COUNT_RANK = v2 + '/wish-zy/count-rank' // 自动计算排名
export const WISH_ZY_SUBMIT = v2 + '/wish-zy/test-submit-for-minapp' // 测录取概率-提交-小程序接口

// 高考录取指南
export const GKLQZN_TIME_SHAFT = v2 + "/gklqzn/timer-shaft" // 时间轴
export const GKLQZN_TAGRGET_INFO = v2 + "/gklqzn/tagrget-info" // 目标大学信息
export const GKLQZN_TAGRGET = v2 + "/gklqzn/tagrget" // 添加修改目标大学信息

export const GKLQZN_OPEN_CLASS = v2 + '/gklqzn/open-class' // 公开课
export const GKLQZN_LIVE_LIST = v2 + '/gklqzn/hot-live-list' // 热门直播
export const GKLQZN_TODAY_REMINDER = apiUrl + v2 + '/gklqzn/today-reminder' // 今日提醒
export const SCHOOL_SET_MYSCHOOL = v2 + '/school/set-myschool' // 设置个人信息
export const GKLQZN_FAST_INFORMATION = v2 + '/gklqzn/fast-information' // 今日提醒

// 捡漏活动
export const JL_DFGL_CONFIG = v2 + '/wish-zy-cors/jl-dfgl-config' // 低分高录配置
export const JL_DFGL = apiUrl + v2 + '/wish-zy-cors/jl-dfgl' // 低分高录
export const JL_ZJYX_CONFIG = v2 + '/wish-zy-cors/jl-zjyx-config' // 征集院校配置
export const JL_ZJYX = apiUrl + v2 + '/wish-zy-cors/jl-zjyx' // 征集院校
export const JL_JLZY_CONFIG = v2 + '/wish-zy-cors/jl-jlzy-config' // 捡漏专业配置
export const JL_JLZY = apiUrl + v2 + '/wish-zy-cors/jl-jlzy' // 捡漏专业
export const JL_XJDX_CONFIG = v2 + '/wish-zy-cors/jl-xjdx-config' // 新建大学配置
export const JL_XJDX = apiUrl + v2 + '/wish-zy-cors/jl-xjdx' // 新建大学


//2024春节活动
export const WISHRED2024_INDEX = v1 + "/wishred2024/index"   //活动主页
export const WISHRED2024_CREATE_RED_WISH = v1 + "/wishred2024/create-red-wish"   //添加心愿
export const WISHRED2024_LIGHT_ON = v1 + "/wishred2024/light-on"   //点灯
export const WISHRED2024_HELPED_LOGS = v1 + "/wishred2024/helped-logs"   //日志列表
export const WISHRED2024_HELPED_INDEX = v1 + "/wishred2024/light-index"   //愿望详情
export const WISHRED2024_OPEN_INDEX = v1 + "/wishred2024/open-index"   //红包开奖主页
export const WISHRED2024_OPEN_PAPER = v1 + "/wishred2024/open-paper"   //红包开启


// 免费预测报告
export const WISHZYCORS_SERVICE_FREE_CONFIG = v2 + '/wish-zy-cors/get-service-free-config' // 获取配置
export const WISHZYCORS_SERVICE_FREE_USERINFO = v2 + '/wish-zy-cors/get-service-free-user-info' // 填报信息
export const WISHZYCORS_SERVICE_FREE_UPDATE = v2 + '/wish-zy-cors/update-service-free-user-info' // 更新填报信息
export const WISHZYCORS_SERVICE_FREE_REPORT= v2 + '/wish-zy-cors/get-service-free-report' // 获取报告
export const WISHZYCORS_COUNT_RANK = v2 + '/wish-zy-cors/count-rank' // 自动计算排名

// 志愿卡特殊优惠券领取
export const WISHZYCARD_COUPON = v2 + '/xuekao-zt/giving-coupon' // 自动计算排名

// 学考志愿卡
export const XUEKAOZY_CARD_PACKAGES = v2 + '/xuekao-zt/wish-card-packages' // 学考志愿卡套餐
export const XUEKAOZY_PAY_FEE_INFO = v2 + '/xuekao-zt/pay-fee-info' // 获取支付信息
export const XK_BUY_CODE_TO_CARD = v2 + '/xuekao-zt/card-giving' // 兑换码兑换卡
export const XK_BUY_CARD_PRE_GENERAL = v2 + '/xuekao-zt/buy-card-pre-general' // 学考志愿卡购买
export const XK_BUY_CARD_POST = v2 + '/xuekao-zt/buy-card-post' // 学考志愿卡购买check
export const XK_LUNBO_XKUSER = v2 + '/xuekao-zt/lunbo-xkuser' // 学考志愿卡轮播图
// 获取优惠券组
export const TRADE_COUPON_GROUP = v2 + '/trade/coupon/coupon-group' // 学考志愿卡优惠券组

// 批量领取优惠券活动模板
export const ACTIVE_SERVICE_ACTIVITY = v1 + '/activity/service-activity'
export const ACTIVE_SERVICE_GET_COUPON = v1 + '/activity/service-activity-get-coupon'
export const ACTIVE_SERVICE_GET_COUPON_CHECK = v1 + '/activity/service-activity-has-coupon' // -判断是否领取优惠券


// 邀请
export const USER_INVITE = v1 + '/user/invite' // 学考锦鲤抽奖
